import { defineNuxtPlugin } from '#app'
import GLightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.css'

export default defineNuxtPlugin(async (nuxtApp) => {
  // Fetch the SVG files as text from public/images/
  const [prevSVG, nextSVG, closeSVG] = await Promise.all([
    fetch('/Images/logos/prev.svg').then(res => res.text()),
    fetch('/Images/logos/next.svg').then(res => res.text()),
    // fetch('/Images/logos/close.svg').then(res => res.text()), // optional
  ])

  const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
    <div class="gloader visible"></div>
    <div class="goverlay background"></div>
    <div class="gcontainer">
      <div id="glightbox-slider" class="gslider"></div>
      <button class="gnext gbtn" tabindex="0" aria-label="Next">${nextSVG}</button>
      <button class="gprev gbtn" tabindex="1" aria-label="Previous">${prevSVG}</button>
      <button class="gclose gbtn" tabindex="2" aria-label="Close">${closeSVG}</button>
    </div>
  </div>`

  const customSlideHTML = `<div class="gslide">
    <div class="gslide-inner-content">
      <div class="ginner-container">
        <div class="gslide-media"></div>
        <div class="gslide-description">
          <div class="gdesc-inner">
            <h4 class="gslide-title"></h4>
            <div class="gslide-desc"></div>
          </div>
        </div>
      </div>
    </div>
  </div>`

  const lightbox = GLightbox({
    lightboxHTML: customLightboxHTML,
    slideHTML: customSlideHTML,
    
    skin: 'supercool',
    width: 900,
    height: 600,
    openEffect: 'fade',
    closeEffect: 'fade',
    loop: true,
    touchNavigation: false,
    draggable: false,
    keyboardNavigation: true,
    closeOnOutsideClick: false,
    dragToleranceY: 0,
  })

  nuxtApp.provide('lightbox', lightbox)
})

